const ACTIONS = {
  ADD_CHILD: "addChild",
  DELETE_CHILD: "deleteChild",
  GET_BIRTHDAY_STATUS: "getBirthdayStatus",
};

export { ACTIONS };
